import styled from 'styled-components/macro';

export const ScLanguageSwitcher = styled.div`
  & .arrow {
    background: transparent;
  }

  & .options-list li.active {
    background: ${({ theme }) => theme.grayColor2};
    font-weight: 600;
  }

  & > div {
    min-width: 150px;

    .options-list > li.with-icon img {
      object-fit: cover;
    }

    .content > .value.with-icon img {
      object-fit: cover;
    }
  }

  @media (hover: hover) {
    & .arrow:hover {
      background-color: transparent !important;
    }

    & .options-list li:hover {
      background: ${({ theme }) => theme.grayColor2};
    }
  }
`;

// Option content is a real link (new tab / middle click) — keep the option look.
export const ScLocaleOptionLink = styled.a`
  color: inherit;
  text-decoration: none;
`;
